
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 200 200"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.825 109.91c-5.562-5.37-5.716-14.233-.345-19.795 5.37-5.562 14.234-5.717 19.796-.346l35.247 34.038 70.856-73.372c5.37-5.562 14.234-5.717 19.796-.346 5.562 5.371 5.716 14.234.345 19.796L94.94 153.33c-5.299 5.486-13.995 5.711-19.569.56l-.227-.215-45.319-43.763z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    